module.exports = __webpack_public_path__ + "img/collection-memoireRingsSlim@2x.93a1302.jpg";